module.exports = __webpack_public_path__ + "img/6.9653d579.png";